<template>
  <header class="header">
    <div class="container">
      <div class="header-content">
        <div class="logo">
          <img :src="logo" alt="PolicyVista" class="logo-img" width="100" height="100"/>
        </div>
        <div class="header-text" v-if="showText">
          <span class="header-subtitle">{{ headerText }}</span>
        </div>
        <div class="header-actions">
          <a href="#" class="call-agent-btn">
            <svg class="phone-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="currentColor"/>
            </svg>
            {{ buttonText }}
          </a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import logo from '@/assets/images/logo.png'

export default {
  name: 'AppHeader',
  props: {
    headerText: {
      type: String,
      default: 'Get quick and cheap car insurance quotes today! Cheapest rates as low as $19/mo+'
    },
    buttonText: {
      type: String,
      default: 'Call an Agent'
    },
    showText: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      logo
    }
  }
}
</script>

<style scoped>
.header {
  background: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
  padding: 5px 0;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
}



.logo {
  flex-shrink: 0;
  height: 100px;
}

.logo-img {
  height: 100px;
  width: 100px;
}

.header-text {
  flex: 1;
  text-align: center;
  padding: 0 1rem;
}

.header-subtitle {
  color: #666;
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.4;
}

.header-actions {
  flex-shrink: 0;
}

.call-agent-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 50px;
  text-decoration: none;
  color: #495057;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.call-agent-btn:hover {
  background: #e9ecef;
  border-color: #dee2e6;
  color: #212529;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.phone-icon {
  width: 16px;
  height: 16px;
  color: #495057;
}

/* Responsive Design */
@media (max-width: 768px) {
  .header {
    padding: 5px 0;
    position: relative;
  }

  .header-content {
    flex-direction: column;
    gap: 0.8rem;
  }

  .logo {
    order: 1;
    align-self: flex-start;
  }

  .header-actions {
    order: 2;
    align-self: flex-end;
    position: absolute;
    top: 0.75rem;
    right: 1rem;
    padding-top: 10px;
  }

  .header-text {
    order: 3;
    display: block;
    width: 100%;
    text-align: left;
    padding: 0;
    /* margin-top: 0.5rem; */
  }

  .logo-img {
    width: 100px;
  }

  .header-subtitle {
    font-size: 1rem;
    line-height: 1.4;
    font-weight: 500;
  }

  .call-agent-btn {
    padding: 0.8rem 1.2rem;
    font-size: 1.0rem;
    font-weight: 600;
  }

  .phone-icon {
    width: 24px;
    height: 24px;
  }
}

@media (max-width: 480px) {
  .header {
    padding: 5px 0;
    position: relative;
  }

  .header-content {
    gap: 0.6rem;
  }

  .header-actions {
    top: 0.6rem;
  }

  /* .logo-img {
    height: 68px;
  } */

  .header-subtitle {
    font-size: 0.9rem;
    line-height: 1.3;
    font-weight: 500;
  }

  .call-agent-btn {
    padding: 0.6rem 1rem;
    font-size: 1.0rem;
    font-weight: 600;
  }

  .phone-icon {
    width: 24px;
    height: 24px;
  }
}
</style>
